import React from 'react';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ActionButtonNoProviderLazy = lazy(() =>
	import(
		/* webpackChunkName: "async-version-detail-issue-list-feature-flag-no-provider-action-button" */ './ActionButtonNoProvider.tsx'
	).then((module) => module.ActionButtonNoProvider),
);

export const ActionButtonNoProviderAsync = (props: Props) => (
	<ActionButtonNoProviderLazy {...props} />
);
